<template>
    <div>
        <m-pane
            ref="tablePage"
            class="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            pageID="vehicleFreePlatform"
            :currentPage="currentPage">
        </m-pane>
    </div>
</template>
<script>
import mPane from '@/components/supplierPanel';
import config from './config.js';
export default {
    components: { mPane },
    mounted() {
        this.load();
    },
    data() {
        return {
            config,
            totalData: [], // table数据
            pageTotal: 0, // 总条数
            loading: false, // table的loading状态
            currentPage: 1 // 当前页数
        };
    },
    methods: {
        load() {
            this.loading = true;
            new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(true);
                }, 1000);
            }).then((res) => {
                this.loading = false;
            });
        }
    }
};
</script>
<style lang="less">
</style>